<template>
  <single-step-generic-view :loading="loading || loadingInfos">
    <ressource code="sous-titre-introduction" class="mb-3"></ressource>
    <v-form v-model="valid" ref="mainForm">
      <template v-if="typeCarteAffaire === 'Perso'">
        <adresse-personnelle :carteAffaire="sas.carteAffaire" two-columns :live="false"></adresse-personnelle>
        <opq-case code="adresse-perso-correspondance" v-model="sas.carteAffaire.adresseDeCorrespondance" optional></opq-case>
      </template>

      <template v-if="typeCarteAffaire === 'Pro'">
        <div v-show="estRetraite">
          <opq-alert code="coordonnees-professionnelles-retraite"></opq-alert>
        </div>
        <div v-show="!estRetraite">
          <template v-if="modification">
            <opq-case
              :opq-if="!sas.carteAffaire.suspenduTemporairement"
              code="emploi-inactif"
              v-model="sas.carteAffaire.inactif"
              optional
              hide-details
              dense
            ></opq-case>
            <opq-date-picker
              :opq-if="sas.carteAffaire.inactif"
              code="emploi-date-fin"
              v-model="sas.carteAffaire.dateFinEmploi"
            ></opq-date-picker>
            <opq-case
              :opq-if="!sas.carteAffaire.inactif"
              code="emploi-suspendu"
              v-model="sas.carteAffaire.suspenduTemporairement"
              optional
              hide-details
              dense
            ></opq-case>
            <province-quebec-flag
              :estProvinceQC="codeProvince(sas.carteAffaire.province) == 'QC'"
              :estCategorieHQ="estCategorie(16)"
              :estInactif="estInactifOuSuspendu"
            />
          </template>
          <template v-if="!estInactifOuSuspendu">
            <province-quebec-flag
              :estProvinceQC="codeProvince(sas.carteAffaire.province) == 'QC'"
              :estCategorieHQ="estCategorie(16)"
              :estInactif="estInactifOuSuspendu"
            />
            <template v-if="!estGuest">
              <template v-if="!est94H">
                <opq-catalogue code="emploi-type" v-model="sas.carteAffaire.typeDEmploi" disabled> </opq-catalogue>
                <opq-catalogue v-if="estPS" code="emploi-profession-psy" v-model="sas.carteAffaire.professionPsy"> </opq-catalogue>

                <opq-text-field
                  code="emploi-nb-heure"
                  v-model="sas.carteAffaire.nombreHeures"
                  is-decimal
                  step="0.5"
                  customRegex="^\d+([.,][05])?$"
                ></opq-text-field>
              </template>

              <opq-catalogue
                v-if="estTypeEmploi(sas.carteAffaire, 'Sal')"
                code="emploi-milieu-travail-1"
                v-model="sas.carteAffaire.milieuTravail1"
                width="500"
                :filter="(fd) => fd.value != sas.carteAffaire.milieuTravail2 && fd.value != sas.carteAffaire.milieuTravail3"
              >
              </opq-catalogue>
              <opq-catalogue
                v-if="estTypeEmploi(sas.carteAffaire, 'Sal')"
                code="emploi-milieu-travail-2"
                v-model="sas.carteAffaire.milieuTravail2"
                optional
                width="500"
                :filter="(fd) => fd.value != sas.carteAffaire.milieuTravail1 && fd.value != sas.carteAffaire.milieuTravail3"
              >
              </opq-catalogue>
              <opq-catalogue
                v-if="estTypeEmploi(sas.carteAffaire, 'Sal')"
                code="emploi-milieu-travail-3"
                v-model="sas.carteAffaire.milieuTravail3"
                optional
                width="500"
                :filter="(fd) => fd.value != sas.carteAffaire.milieuTravail1 && fd.value != sas.carteAffaire.milieuTravail2"
              >
              </opq-catalogue>

              <template v-if="!est94H">
                <opq-catalogue
                  :opq-if="estTypeEmploi(sas.carteAffaire, 'Pri')"
                  code="emploi-milieu-pratique"
                  v-model="sas.carteAffaire.milieuxDePratique"
                  optional
                >
                </opq-catalogue>

                <opq-case code="emploi-correspondance" v-model="sas.carteAffaire.adresseDeCorrespondance" optional></opq-case>
              </template>
            </template>

            <search-organisation
              v-if="estTypeEmploi(sas.carteAffaire, 'Sal') && !modification"
              @organisation-selected="organisationSelected($event)"
            ></search-organisation>

            <opq-text-field
              v-if="estTypeEmploi(sas.carteAffaire, 'Sal')"
              code="emploi-organisation"
              v-model="sas.carteAffaire.nomEmployeur"
              ref="nomEmployeur"
              :disabled="modification"
            ></opq-text-field>
            <opq-text-field
              v-if="estTypeEmploi(sas.carteAffaire, 'Pri')"
              code="emploi-raison-sociale"
              v-model="sas.carteAffaire.raisonSociale"
              optional
            ></opq-text-field>
            <opq-text-field
              code="emploi-departement"
              v-if="!estGuestOu94H && estTypeEmploi(sas.carteAffaire, 'Sal')"
              v-model="sas.carteAffaire.departement"
              optional
            ></opq-text-field>

            <opq-alert v-if="estPS" v-show="estCategorie(16)" code="avertissement-province-HQ"></opq-alert>

            <adresse-professionnelle :carteAffaire="sas.carteAffaire" :live="false" :disabled="modification" ref="adresse"></adresse-professionnelle>

            <opq-catalogue
              code="informations-confidentielles"
              :opq-if="affichageInformationsConfidentielles"
              v-model="sas.carteAffaire.informationsConfidentielles"
              optional
            >
            </opq-catalogue>

            <template v-if="est94H">
              <h3 class="title mb-3">
                <ressource code="superviseurs-titre-section"></ressource>
              </h3>
              <data-iterator
                :list="sas.superviseurs"
                add-new-text="Ajouter un superviseur"
                :icon="$getIcon('teacher')"
                :valids="valids"
                ref="dataIterator"
                @addItem="addSuperviseur"
              >
                <template v-slot:show-mode="{ item }">
                  <h3 class="mb-3">{{ superviseurTitle(item) }}</h3>
                  <opq-case v-if="item.undeletable" optional code="superviseur_inactif" v-model="item.inactif"></opq-case>
                  <opq-date-picker
                    v-if="item.inactif"
                    code="date_fin_superviseur"
                    :minYear="new Date().getFullYear()"
                    v-model="item.dateFin"
                  ></opq-date-picker>
                </template>
                <template v-slot:edit-mode="{ item }">
                  <template v-if="item.numeroPermis">
                    <h3 class="mb-3">{{ superviseurTitle(item) }}</h3>
                    <opq-date-picker
                      code="date_debut_superviseur"
                      :minYear="new Date().getFullYear()"
                      v-model="item.dateDebut"
                      :optional="!!item.id"
                    ></opq-date-picker>
                    <opq-file
                      code="attestation_superviseur"
                      :file="item.attestation"
                      v-model="item.attestationInput"
                      :optional="!!item.id"
                    ></opq-file>
                  </template>
                  <template v-else>
                    <search-numero-permis @contact-selected="contactSelected($event, item)"></search-numero-permis>
                    <v-checkbox
                      class="list_counter_validator my-2 ml p-0"
                      :input-value="item.numeroPermis"
                      :rules="[(v) => !!v || 'Veuillez sélectionner un superviseur par numéro de permis.']"
                    ></v-checkbox>
                  </template>
                </template>
              </data-iterator>
              <v-checkbox
                class="list_counter_validator my-2 ml p-0"
                :input-value="sas.superviseurs.some(x => !x.inactif)"
                :rules="[(v) => !!v || 'Vous devez avoir au moins un superviseur pour cette adresse professionelle.']"
              ></v-checkbox>
            </template>

            <template v-if="!estGuestOu94H">
              <opq-catalogue code="emploi-accessible" v-model="sas.carteAffaire.accessible"> </opq-catalogue>
              <div v-show="estNonMembre || estPS">
                <div>
                  <ressource code="separateur-assurance"></ressource>
                </div>
                <div>
                  <ressource code="description-assurance"></ressource>
                </div>
              </div>

              <!-- CAS-3232, à réintégrer après la MeP du 2026/09/16 -->
              <!--
              <opq-catalogue
                code="assurance-organisation"
                :opq-if="estTypeEmploi(sas.carteAffaire, 'Pri') && jexercePsychologue(item.professionPsy)"
                v-model="sas.carteAffaire.organisationAUneAssurance"
                @eudo-updated="organisationAUneAssuranceChanged(sas.carteAffaire)"
              >
              </opq-catalogue>
              -->

              <opq-alert
                v-if="(estNonMembre || estPS) && estTypeEmploi(sas.carteAffaire, 'Pri')"
                code="description-assurance-pratique-prive"
              ></opq-alert>
              <opq-alert v-if="(estNonMembre || estPS) && estTypeEmploi(sas.carteAffaire, 'Sal')" code="description-assurance-employeur"></opq-alert>
              <!-- CAS-3232, à réintégrer après la MeP du 2026/09/16 -->
              <!--
              <opq-catalogue
                :opq-if="(estNonMembre || estPS) &&
                  jexercePsychologue(sas.carteAffaire.professionPsy) &&
                  (estTypeEmploi(sas.carteAffaire, 'Sal') || estOui(sas.carteAffaire.organisationAUneAssurance))"
                code="emploi-motif-exemption"
                v-model="sas.carteAffaire.motifExemptionAssurance"
                :ref="'motifExemptionAssurance' + sas.carteAffaire.id"
                :disabled="isExemptionDisabled(sas.carteAffaire)"
                :hidden="isExemptionDisabled(sas.carteAffaire)"
              >
              </opq-catalogue>
              -->
              <!-- CAS-3232, ancienne version du catalogue, à supprimer après la MeP du 2026/09/16 -->
              <opq-catalogue
                v-if="(estNonMembre || estPS) && estTypeEmploi(sas.carteAffaire, 'Sal') && jexercePsychologue(sas.carteAffaire.professionPsy)"
                code="emploi-motif-exemption"
                v-model="sas.carteAffaire.motifExemptionAssurance"
                :ref="'motifExemptionAssurance' + sas.carteAffaire.id"
              >
              </opq-catalogue>

              <opq-alert
                v-show="sas.carteAffaire.motifExemptionAssurance"
                :code="'information-exemption-assurance-' + getCatalogueCodeById(437, sas.carteAffaire.motifExemptionAssurance)"
              ></opq-alert>

              <!-- CAS-3232, à réintégrer après la MeP du 2026/09/16 -->
              <!--
              <opq-file
                :opq-if="['08'].indexOf(getCatalogueCodeById(437, sas.carteAffaire.motifExemptionAssurance)) > -1"
                code="emploi-attestation-assurance"
                :file="sas.carteAffaire.attestationExemptionAssurance"
              >
              </opq-file>
              -->

              <opq-text-field
                code="emploi-numero-assurance"
                v-if="
                  (estNonMembre || estPS) &&
                  !estRetraite &&
                  employeurs.some(
                    (e) =>
                      !e.inactif &&
                      (!estPS || jexercePsychologue(e.professionPsy)) &&
                      (estTypeEmploi(e, 'Pri') || (estTypeEmploi(e, 'Sal') && getCatalogueCodeById(437, e.motifExemptionAssurance) == '10'))
                  )
                "
                v-model="sas.numeroAssurance"
                optional
              ></opq-text-field>
            </template>
          </template>
          <opq-relation
            v-if="!estGuestOu94H"
            code="domicile-professionnel"
            v-model="sas.domicileProfessionnel"
            :list="choixDomicilesProfessionnels"
            :item-text="(e) => affichageTexteDomicileProfessionnel(e)"
            ref="domicileProfessionnel"
            width="400"
            :disabled="!!domicileProfessionnelWithMaxHeures && !domicileProfessionnelEstAdressePersonnelle"
          ></opq-relation>
        </div>
      </template>
    </v-form>
    <opq-alert type="warning" class="mt-6" code="aucun-champ-modifie" max-width="700" v-show="aucunChampModifie"></opq-alert>
    <opq-alert type="warning" class="mt-6" code="formulaire-incomplet" max-width="700" v-show="formulaireNonValide"></opq-alert>
    <div class="mt-6">
      <v-btn x-large dark color="#3a3838" @click="submit">Soumettre</v-btn>
    </div>
  </single-step-generic-view>
</template>

<script>
import { mapGetters } from "vuex"
import SingleStepFormulaireViewBase from "@/mixins/SingleStepFormulaireViewBase"
import FormulaireBase from "@/mixins/FormulaireBase"
import AdressePersonnelle from "@/components/FormParts/AdressePersonnelle"
import AdresseProfessionnelle from "@/components/FormParts/AdresseProfessionnelle"
import FormHybrid from "@/mixins/FormHybrid"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import ProvinceQuebecFlag from "@/components/Common/ProvinceQuebecFlag.vue"
import Introduction from "@/components/FormParts/Introduction"
import { Api } from "@/plugins/api"
import SearchOrganisation from "@/components/Common/SearchOrganisation"
import SearchNumeroPermis from "@/components/Common/SearchNumeroPermis"
export default {
  mixins: [SingleStepFormulaireViewBase, FormulaireBase, FormHybrid, CataloguesHelper],

  data() {
    return {
      paramsName: "modification-adresse",
      carteAffaireOriginale: undefined,
      superviseursOriginaux: undefined,
      numeroAssuranceOriginal: undefined,
      sas: undefined,
      aucunChampModifie: false,
      loadingInfos: true
    }
  },
  methods: {
    createdCustom() {
      Api.get("/modification-carte-affaire/has-access?token=" + this.encodedToken)
        .then((res) => {
          if (!res.data) {
            this.$router.push({ name: "RenouvellementEnCours" })
          }
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$router.push({
              name: "NotFound",
            })
          } else if (error.response.status === 401) {
            this.$router.push({
              name: "Unauthorized",
            })
          } else {
            this.$router.push({
              name: "InternalError",
            })
          }
        })

      let url = `/modification-carte-affaire`
      if (this.$route.query.carteAffaireId) {
        url += `?carteAffaireId=${this.$route.query.carteAffaireId}&`
      } else {
        url += `/create?typeEmploi=${this.$route.query.typeEmploi}&`
      }

      url += `token=${this.encodedToken}`
      this.loadingInfos = true
      Api.get(url)
        .then((res) => {
          this.carteAffaireOriginale = { ...res.data.carteAffaire }
          this.superviseursOriginaux = res.data.superviseurs ? [...res.data.superviseurs] : []
          this.numeroAssuranceOriginal = res.data.numeroAssurance
          this.sas = JSON.parse(JSON.stringify(res.data))
          if (this.domicileProfessionnelWithMaxHeures) {
            this.sas.domicileProfessionnel = this.domicileProfessionnelWithMaxHeures
          }
          this.loadingInfos = false
        })
        .catch(() => {
          this.$router.push({ name: "Unauthorized" })
        })
    },
    estCategorie(codeCategorie) {
      return this.getCatalogueCodeById(11124, this.sas.categorieAdhesion) == codeCategorie
    },
    estTypeEmploi(item, type) {
      return this.getCatalogueCodeById(2902, item.typeDEmploi) == type
    },
    organisationSelected(organisation) {
      // On doit déclencher la modification des champs 2 fois pour passer par-dessus l'écrasement de v-facade
      this.updateChamps(organisation)
      setTimeout(() => {
        this.updateChamps(organisation)
      }, 200)
    },
    superviseurTitle(item) {
      return item.numeroPermis ? `${item.prenom} ${item.nom} (${item.numeroPermis})` : "Veuillez renseigner votre superviseur"
    },
    contactSelected(contact, superviseur) {
      superviseur.contactId = contact.id
      superviseur.nom = contact.nom
      superviseur.prenom = contact.prenom
      superviseur.numeroPermis = contact.numeroPermis
    },
    addSuperviseur() {
      this.sas.superviseurs.push({
        contactId: "",
        isExpanded: true,
        nom: "",
        prenom: "",
        numeroPermis: "",
        dateDebut: null,
        dateFin: null,
        attestationInput: undefined
      })
    },
    updateChamps(organisation) {
      this.sas.carteAffaire.nomEmployeur = organisation.nomEmployeur
      this.sas.carteAffaire.adresse = organisation.adresse
      this.sas.carteAffaire.complementAdresse = organisation.complementAdresse
      this.sas.carteAffaire.ville = organisation.ville
      this.sas.carteAffaire.province = organisation.province
      this.sas.carteAffaire.pays = organisation.pays
      this.sas.carteAffaire.codePostal = organisation.codePostal
      this.sas.carteAffaire.noteDAcces = organisation.noteDAcces
    },
    submitCustom() {
      this.aucunChampModifie = false
      let url = `/modification-carte-affaire?token=${this.encodedToken}`
      if (this.modification) {
        url += `&carteAffaireId=${this.$route.query.carteAffaireId}`
      }
      if (!this.modification || this.checkDiff()) {
        return Api.post(url, {
          ...this.sas,
          domicileProfessionnelEstNouvelleCarteAffaire: this.domicileProfessionnelEstNouvelleCarteAffaire
        })
      } else {
        this.aucunChampModifie = true
      }
    },
    checkDiff() {
      let comparer = Object.keys(this.carteAffaireOriginale).map((key) => this.compareField(key))
      comparer.push(this.compare(this.numeroAssuranceOriginal, this.sas.numeroAssurance))
      let hasNewSuperviseur = this.superviseursOriginaux.length < this.sas.superviseurs.length
      let superviseurInactif = this.sas.superviseurs.some((x) => x.inactif)
      let diffs = comparer.filter((e) => !e)
      return diffs.length > 0 || hasNewSuperviseur || superviseurInactif
    },
    compareField(key) {
      const oldValue = this.carteAffaireOriginale[key]
      const newValue = this.sas.carteAffaire[key]
      return this.compare(oldValue, newValue)
    },
    compare(oldValue, newValue) {
      if (typeof oldValue === typeof newValue) {
        if (typeof oldValue === "string" || typeof oldValue === "boolean") {
          return oldValue === newValue
        }
        if (typeof oldValue === "object") {
          if (oldValue === null && newValue === null) {
            return true
          }
          if (oldValue === null || newValue === null) {
            return false
          }
          if (oldValue.length === 0 && newValue.length === 0) {
            return true
          }
          if (oldValue.length > 0 && newValue.length > 0) {
            return oldValue.every((v) => newValue.indexOf(v) > -1) && newValue.every((v) => oldValue.indexOf(v) > -1)
          }
          return false
        }
      }
      if (oldValue === null && newValue === "") {
        return true
      }
      if (newValue === null && oldValue === "") {
        return true
      }
      return false
    },
    affichageTexteDomicileProfessionnel(carteAffaire) {
      let result = ""
      if (carteAffaire.nomEmployeur) {
        result += carteAffaire.nomEmployeur + " - "
      }
      if (carteAffaire.raisonSociale) {
        result += carteAffaire.raisonSociale + " - "
      }
      if (carteAffaire.adresse) {
        result += carteAffaire.adresse + ", "
      }
      if (carteAffaire.ville) {
        result += carteAffaire.ville + ", "
      }
      if (carteAffaire.codePostal) {
        result += carteAffaire.codePostal
      }
      return result
    },
    organisationAUneAssuranceChanged(item) {
      if (this.estOui(item.organisationAUneAssurance)) {
        this.$refs["motifExemptionAssurance" + item.id].setValueByCode("08")
      }
    },
    jexercePsychologue(item) {
      if (item == this.$catalogues.SasCarteAffaire.ProfessionPsy.Jexerce) {
        return true
      }
      return false
    },
    jexercePasPsychologue(item) {
      if (item == this.$catalogues.SasCarteAffaire.ProfessionPsy.JexercePas) {
        return true
      }
      return false
    },
    isExemptionDisabled(item) {
      if (this.estOui(item.organisationAUneAssurance)) {
        return true
      }
      return false
    },
  },

  components: {
    Introduction,
    AdressePersonnelle,
    AdresseProfessionnelle,
    ProvinceQuebecFlag,
    SearchOrganisation,
    SearchNumeroPermis
  },

  computed: {
    ...mapGetters(["catalogues"]),
    estNonMembre() {
      return this.estCategorie(23) || this.estCategorie(24)
    },
    estPS() {
      return this.$route.query.typeMembre === "PS"
    },
    estPT() {
      return this.$route.query.typeMembre === "PT"
    },
    est94H() {
      return this.$route.query.typeMembre === "94H"
    },
    estGuest() {
      return this.$route.query.typeMembre === "GUEST"
    },
    estGuestOu94H() {
      return this.estGuest || this.est94H
    },
    modification() {
      return !!this.$route.query.carteAffaireId
    },
    typeCarteAffaire() {
      return this.sas?.carteAffaire.codeTypeCarteDAffaire
    },
    estRetraite() {
      return this.estCategorie(15)
    },
    estInactifOuSuspendu() {
      return this.sas?.carteAffaire.inactif || this.sas?.carteAffaire.suspenduTemporairement
    },
    encodedToken() {
      const token = this.$route.query.token.replace(/\s/g, "+")
      return encodeURIComponent(token)
    },
    employeurs() {
      return [...this.sas.cartesAffaires, this.sas.carteAffaire]
    },
    employeursActifs() {
      if (this.typeCarteAffaire == null || this.typeCarteAffaire === "Perso") {
        return []
      }
      return this.employeurs.filter((e) => !e.inactif) ?? []
    },
    employeursProfessionPsy() {
      return this.employeursActifs.filter((e) => !this.estPS || this.jexercePsychologue(e.professionPsy))
    },
    choixDomicilesProfessionnels() {
      if (this.multipleDomicilesProfessionPsyEgalHeure) {
        return this.employeursProfessionPsy.filter((e) => e.nombreHeures == this.maxHeures)
      }
      return [...this.employeursActifs, this.sas.adressePersonnelle]
    },
    maxHeures() {
      if (this.employeursProfessionPsy.length == 1) {
        return parseFloat(this.employeursProfessionPsy[0].nombreHeures)
      }
      if (this.employeursProfessionPsy.length > 1) {
        let max = 0
        for (let i = 0; i < this.employeursProfessionPsy.length; i++) {
          let current = parseFloat(this.employeursProfessionPsy[i].nombreHeures) || 0
          if (current > max) {
            max = current
          }
        }
        return max
      }
      return null
    },
    multipleDomicilesProfessionPsyEgalHeure() {
      return this.employeursProfessionPsy.filter((e) => e.nombreHeures == this.maxHeures).length > 1
    },
    domicileProfessionnelWithMaxHeures() {
      if (this.employeursProfessionPsy.length == 1) {
        return this.employeursProfessionPsy[0].id
      }

      let founds = this.employeursProfessionPsy.filter((e) => e.nombreHeures == this.maxHeures)
      if (this.maxHeures) {
        if (founds.length == 1) {
          return founds[0].id
        }
      }
      return null
    },
    domicileProfessionnelEstNouvelleCarteAffaire() {
      return this.domicileProfessionnelWithMaxHeures == this.sas.carteAffaire.id
    },
    domicileProfessionnelEstAdressePersonnelle() {
      return this.domicileProfessionnelWithMaxHeures == this.sas.adressePersonnelle.id
    },
    affichageInformationsConfidentielles() {
      if ((this.estPS || this.estPT)
        && !this.domicileProfessionnelEstNouvelleCarteAffaire) {
        return true
      }

      return false
    }
  },

  watch: {
    domicileProfessionnelWithMaxHeures() {
      this.$refs.domicileProfessionnel?.setValue(this.domicileProfessionnelWithMaxHeures)
    }
  },
  metaInfo() {
    return {
      title: this.$i18n.t("meta.formulaires.title")
    }
  }
}
</script>
